
import { Vue, Component, Prop } from 'vue-property-decorator';

import { RewardsProgramFormState } from '@/models/rewards-program';
import { ERewardsProgramStepSlug } from './RewardsProgramModal.vue';

@Component({})
export default class RewardsProgramCommon extends Vue {
  @Prop() rewardsProgramFormData!: RewardsProgramFormState;

  ERewardsProgramStepSlug = ERewardsProgramStepSlug;
}
